<span [ngSwitch]="log?.action">
    <span *ngSwitchCase="'Create'">{{ ('NEW_VISIT_WAS_SCHEDULED_FOR' | translate) + ' ' }}</span>
    <span *ngSwitchCase="'Delete'">{{ ('VISIT_WAS_DELETED_FOR' | translate) + ' ' }}</span>
    <span *ngSwitchCase="'Modify'">{{ ('SCHEDULED_VISIT_WAS_EDITED_FOR' | translate) + ' ' }}</span>

    <a [routerLink]="['/camera-configuration', $safeNavigationMigration(log?.details?.targetId) ]" (click)="closeDialog.emit()">
        {{ log?.details?.targetName }}
    </a>

    <span *ngIf="!log?.staffId && log?.staffName === 'Everon Admin';else elseBlock"
        [innerHTML]="(('BY_USER' | translate : { targetString : 'Everon Admin' }) | strongWrap : 'Everon Admin')">
    </span>

    <ng-template #elseBlock>
        <span [innerHTML]="(('BY_USER' | translate :
            {
                targetString : $safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId)
            }) | anchorWrap : ($safeNavigationMigration(log?.staffName) | identityFormat : $safeNavigationMigration(log?.staffId)) : $safeNavigationMigration(log?.staffId) : 'Staff' : '' : true)">
        </span>
    </ng-template>
</span>
<p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>

<hr />

<!-- Create / Delete view -->
<ng-container *ngIf="log?.action !== 'Modify'">
    <div class="container">
        <!-- Weekdays -->
        <span class="item-title">{{ "WEEKDAY" | translate }}:</span>
        <div class="item-pair-value">
            <span [ngClass]="{'positive-highlight': log?.action === 'Create', 'negative-highlight line-through': log?.action === 'Delete' }">
                {{ ($safeNavigationMigration(visitChanges?.weekdayTranslationCodes) | translateMultiple) | join : ', ' || "NONE" | translate }}
            </span>
        </div>

        <!-- Time -->
        <span class="item-title">{{ "TIME_TEXT" | translate }}:</span>
        <div class="item-pair-value">
            <span [ngClass]="{'positive-highlight': log?.action === 'Create', 'negative-highlight line-through': log?.action === 'Delete' }">
                {{ (formatTime($safeNavigationMigration(visitChanges?.startTime)) + " - " + formatTime($safeNavigationMigration(visitChanges?.endTime))) || "NONE" | translate }}
            </span>
        </div>

        <!-- Extended visit time -->
        <span class="item-title">{{ "EXTENDED_VISIT_TIME" | translate }}:</span>
        <div class="item-pair-value">
            <span [ngClass]="{'positive-highlight': log?.action === 'Create', 'negative-highlight line-through': log?.action === 'Delete' }">
                {{ ( visitChanges?.extendedVisitTimeMinutes + " " + ("MINUTES" | translate))|| "NONE" | translate }}
            </span>
        </div>
    </div>
</ng-container>

<!-- Modify view -->
<ng-container *ngIf="log?.action === 'Modify'">
    <div class="container">
        <!-- Weekday -->
        <ng-container *ngIf="weekdayCode()">
            <span class="item-title">{{ "WEEKDAY" | translate }}:</span>
            <div class="item-pair-value">
                <span>{{ weekdayCode() | translate }}</span>
            </div>
        </ng-container>

        <!-- Start/end time -->
        <ng-container *ngIf="visitEditChanges?.startTime || visitEditChanges?.endTime">
            <span class="item-title">{{ "TIME_TEXT" | translate }}:</span>
            <div class="item-pair-value">
                <ng-container *ngIf="timeChanged(); else unchangedTime">
                    <span class="negative-highlight line-through">
                        {{ (visitEditChanges?.startTime?.oldValue || visitEditChanges?.endTime?.oldValue) ?
                            (formatTime($safeNavigationMigration(visitEditChanges?.startTime?.oldValue)) + ' - ' + formatTime($safeNavigationMigration(visitEditChanges?.endTime?.oldValue))) :
                            ("NONE" | translate) }}
                    </span>
                    <i class="fa-light fa-arrow-right-long fa-lg"></i>
                    <span class="positive-highlight">
                        {{ (visitEditChanges?.startTime?.newValue || visitEditChanges?.endTime?.newValue) ?
                            (formatTime($safeNavigationMigration(visitEditChanges?.startTime?.newValue)) + ' - ' + formatTime($safeNavigationMigration(visitEditChanges?.endTime?.newValue))) :
                            ("NONE" | translate) }}
                    </span>
                </ng-container>
                <ng-template #unchangedTime>
                    <span>
                        {{ formatTime($safeNavigationMigration(visitEditChanges?.startTime?.newValue)) + ' - ' + formatTime($safeNavigationMigration(visitEditChanges?.endTime?.newValue)) }}
                    </span>
                </ng-template>
            </div>
        </ng-container>

        <!-- Extended visit time -->
        <ng-container *ngIf="visitEditChanges?.extendedVisitTimeMinutes">
            <span class="item-title">{{ "EXTENDED_VISIT_TIME" | translate }}:</span>
            <div class="item-pair-value">
                <span class="negative-highlight line-through">
                    {{ visitEditChanges?.extendedVisitTimeMinutes?.oldValue + ' ' + ("MINUTES" | translate) }}
                </span>
                <i class="fa-light fa-arrow-right-long fa-lg"></i>
                <span class="positive-highlight">
                    {{ visitEditChanges?.extendedVisitTimeMinutes?.newValue + ' ' + ("MINUTES" | translate) }}
                </span>
            </div>
        </ng-container>
    </div>
</ng-container>
